import { Link } from "react-router-dom";
import productData from "../data/productData";
import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
const Home = () => {
  const featuredProducts = productData.slice(0, 4);

  const [products, setProducts] = useState([]);
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "products"));
        const productList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProducts(productList);
      } catch (error) {
        console.error("Error fetching products: ", error);
      }
    };

    fetchProducts();
  }, []);

  return (
    <main className="bg-gradient-to-br from-rose-50 to-white text-gray-800">

      {/* Hero Section */}
      <section
        data-aos="fade-up"
        className="relative min-h-screen flex flex-col items-center justify-center text-center px-4 bg-no-repeat bg-center bg-cover"
        style={{
          backgroundImage: "url('https://res.cloudinary.com/dri1qrcuu/image/upload/v1753957828/bg_pztkhx.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-white bg-opacity-40" />
        <div className="relative max-w-3xl p-6 sm:p-8 rounded-xl z-10">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-serif text-rose-700 mb-4 sm:mb-6">
            Welcome to GlowAura
          </h1>
          <p className="text-base sm:text-lg text-gray-700 mb-6 sm:mb-8">
            Discover the power of nature in every drop. Clean, conscious skincare made with love.
          </p>
          <Link
            to="/products"
            className="bg-rose-600 hover:bg-rose-700 text-white px-6 py-3 rounded-full text-base sm:text-lg transition duration-300"
          >
            Explore Our Products
          </Link>
        </div>
      </section>

      {/* About Section */}
      <section data-aos="fade-up" className="py-16 sm:py-20 px-4 sm:px-6 text-center bg-white">
        <h2 className="text-3xl sm:text-4xl font-bold text-rose-600 mb-4">About GlowAura</h2>
        <p className="max-w-3xl mx-auto text-base sm:text-lg text-gray-700 leading-relaxed">
          At GlowAura, we believe skincare should be gentle, natural, and effective. Our products are crafted from ethically sourced ingredients to nourish your skin and bring out its inner glow. Whether you're starting your skincare journey or refining your routine, GlowAura is here for you.
        </p>
      </section>

      {/* Featured Products */}
      <section className="py-12 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-2xl sm:text-3xl font-semibold text-rose-700 mb-8 text-center">Featured Products</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6">
            
            {products.slice(0, 4).map((product) => (
              <div key={product.id} className="bg-white shadow-md rounded-lg p-4 text-center">
                 <Link
                                to={`/product/${product.id}`}
                              >
                                <img
                              src={product.image}
                              alt={product.name}
                              className="w-full h-52 object-cover rounded-md mb-4"
                            />
                              </Link>
                
                <h3 className="text-lg font-semibold text-gray-800">{product.name}</h3>
                <p className="text-rose-600 font-bold mt-2">₹{product.price}</p>
                <Link
                  to={`/product/${product.id}`}
                  className="inline-block mt-4 bg-rose-600 text-white px-4 py-2 rounded-full text-sm hover:bg-rose-700 transition"
                >
                  View Product
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section data-aos="fade-up" className="py-16 sm:py-20 px-4 sm:px-6 text-center bg-white">
        <h2 className="text-3xl sm:text-4xl font-bold text-rose-600 mb-10 sm:mb-12">What Our Customers Say</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-10 max-w-5xl mx-auto">
          <div className="bg-rose-100 p-6 rounded-lg shadow">
            <p className="italic">“My skin feels so soft and refreshed. GlowAura’s serum is a game changer!”</p>
            <p className="mt-4 font-semibold">— Ananya R.</p>
          </div>
          <div className="bg-rose-100 p-6 rounded-lg shadow">
            <p className="italic">“I've tried many brands, but nothing feels as natural and effective as GlowAura.”</p>
            <p className="mt-4 font-semibold">— Meera K.</p>
          </div>
        </div>
      </section>

      {/* Contact Call to Action */}
      <section data-aos="fade-up" className="py-16 sm:py-20 px-4 sm:px-6 bg-rose-600 text-white text-center">
        <h2 className="text-3xl sm:text-4xl font-bold mb-4">Ready to Glow Naturally?</h2>
        <p className="text-base sm:text-lg mb-6 max-w-2xl mx-auto">
          Get in touch with us for custom skincare solutions or bulk orders.
        </p>
        <Link
          to="/contact"
          className="bg-white text-rose-600 px-6 py-3 rounded-full text-base sm:text-lg hover:bg-rose-100 transition"
        >
          Contact Us
        </Link>
      </section>

      {/* Footer */}
      <footer className="py-8 px-6 text-center text-gray-600 bg-rose-100">
        <p className="text-sm">&copy; {new Date().getFullYear()} GlowAura. All rights reserved.</p>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-4 text-sm">
          <a href="#" className="hover:text-rose-700 transition">Instagram</a>
          <a href="#" className="hover:text-rose-700 transition">Facebook</a>
          <a href="#" className="hover:text-rose-700 transition">Privacy Policy</a>
        </div>
      </footer>
    </main>
  );
};

export default Home;
